import IconDialog from '@/components/dialog/IconDialog'

export default {
  components: {
    IconDialog
  },
  data () {
    return {
      iconDialog: {
        loading: false
      }
    }
  }
}
